import React from 'react';
import './SecuritySolutionsOffer.css';
import a from './img1.png';
import b from './img2.png';

const fitItems = [
    'עסקים שמחזיקים מידע רגיש או מערכות קריטיות.',
    'חברות שצריכות פיתוח מאובטח יותר ושילוב DevSecOps.',
    'ארגונים שרוצים לשפר את רמת ההגנה בתשתיות ובסביבות ענן.',
    'עסקים שצריכים לזהות חולשות מוקדם יותר ולצמצם סיכון.',
    'חברות שרוצות לחזק אבטחה בלי להכביד על הפעילות.',
    'ארגונים בינוניים שצריכים ליווי אבטחתי פרקטי בלי להקים מערך כבד.'
];

const problemItems = [
    'אין מספיק שליטה על סיכוני אבטחה.',
    'המערכת עובדת, אבל אין ודאות שהיא בנויה נכון מבחינת אבטחה.',
    'חסרים תהליכי פיתוח מאובטחים.',
    'הגנת הנתונים אינה מסודרת מספיק.',
    'יש יותר מדי תלות באנשי פיתוח או ספקים בלי בקרה אבטחתית ברורה.',
    'אין נראות מספקת לחולשות ולנקודות תורפה.',
    'תהליכי פריסה או תשתית אינם כוללים בקרות אבטחה מספיקות.',
    'לא ברור איפה יש סיכון אמיתי ובמה צריך לטפל קודם.'
];

const audienceSignals = [
    'אם אתם יודעים שהמערכת או התשתית שלכם צריכות רמת הגנה גבוהה יותר.',
    'אם אתם מפתחים או מפעילים מערכות בלי מספיק בקרות אבטחה לאורך הדרך.',
    'אם יש לכם מידע רגיש ואתם לא רוצים לגלות חולשה רק אחרי אירוע.',
    'אם אתם צריכים גישה אבטחתית מעשית שמשתלבת בפיתוח, בתפעול ובענן.',
    'אם אתם רוצים לעשות סדר באבטחה בלי לעצור את קצב העבודה.'
];

const processSteps = [
    {
        number: '01',
        title: 'שיחת היכרות והבנת הסביבה',
        text: 'ממפים את המערכת, התשתיות, אופי המידע והסיכונים העסקיים.'
    },
    {
        number: '02',
        title: 'ניתוח מצב קיים',
        text: 'מזהים נקודות חולשה, פערי בקרה, תהליכים חשופים וסיכונים מרכזיים.'
    },
    {
        number: '03',
        title: 'בניית כיוון ברור לשיפור',
        text: 'מגדירים סדרי עדיפויות, הקשחה, בקרות וצעדים ישימים לשיפור ההגנה.'
    },
    {
        number: '04',
        title: 'ליווי ביישום ובהמשך',
        text: 'מלווים את ההטמעה, הבקרה והמשך השיפור בצורה שמתאימה לעבודה השוטפת.'
    }
];

const trustPoints = [
    'ניסיון בפיתוח, תשתיות, ענן ואבטחה.',
    'גישה פרקטית שמחוברת למערכות אמיתיות, לא רק למסמכים.',
    'חיבור בין צרכים עסקיים, פיתוח, תפעול והגנה.',
    'אבטחה שמשתלבת בתהליכים בלי ליצור עומס מיותר.'
];

const bookingUrl = 'https://meetings.hubspot.com/viacheslav-seifer';

const SecuritySolutionsOffer = () => {
    const scrollToForm = () => {
        const formElement = document.getElementById('epic-security-form');
        if (formElement) {
            formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <section className="security-solutions-offer">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-9 text-center">
                        <h2 className="offer-title">אבטחת מידע וסייבר לעסקים שצריכים הגנה אמיתית, לא רק שכבת אבטחה על הנייר</h2>
                        <p className="lead offer-description">
                            אנחנו עוזרים לעסקים לבנות מערכות ותשתיות מאובטחות יותר, לשלב
                            פרקטיקות DevSecOps, להגן על מידע רגיש ולצמצם חולשות לפני שהן הופכות
                            לסיכון אמיתי.
                        </p>
                        <div className="security-cta-row">
                            <button
                                type="button"
                                className="btn btn-primary btn-lg cta-btn"
                                onClick={scrollToForm}
                            >
                                השאירו פרטים
                            </button>
                            <a
                                href={bookingUrl}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-outline-primary btn-lg cta-btn"
                            >
                                קבעו שיחת ייעוץ
                            </a>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">למי זה מתאים</h3>
                            <div className="bullet-grid">
                                {fitItems.map((item) => (
                                    <div key={item} className="bullet-card">
                                        <span className="bullet-icon">•</span>
                                        <p>{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">האם זה נשמע מוכר?</h3>
                            <div className="bullet-grid">
                                {problemItems.map((item) => (
                                    <div key={item} className="bullet-card">
                                        <span className="bullet-icon">•</span>
                                        <p>{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row align-items-center security-main-section">
                    <div className="col-md-6">
                        <h3>אבטחה טובה לא מתחילה אחרי התקלה</h3>
                        <p>
                            עסקים רבים זזו מהר כדי לעלות לאוויר או לצמוח. עכשיו הם צריכים בסיס
                            אבטחתי חזק יותר, בקרות ברורות והגנה טובה יותר על מערכות, תשתיות
                            ותהליכי פיתוח.
                        </p>
                        <p>
                            המטרה היא לא רק לעמוד בדרישות אבטחה, אלא לצמצם חשיפה, להגן על מידע
                            רגיש ולמנוע בעיות לפני שהן הופכות לנזק תפעולי, עסקי או תדמיתי.
                        </p>
                        <div className="signal-list">
                            {audienceSignals.map((item) => (
                                <div key={item} className="signal-item">{item}</div>
                            ))}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img src={a} alt="פיתוח מאובטח והגנה על מידע" className="img-fluid" />
                    </div>
                </div>

                <div className="row align-items-center security-secondary-section">
                    <div className="col-md-6">
                        <img src={b} alt="DevSecOps, בדיקות אבטחה והקשחת תהליכים" className="img-fluid" />
                    </div>
                    <div className="col-md-6">
                        <h3>איך אנחנו עוזרים</h3>
                        <p>
                            אנחנו משלבים פרקטיקות DevSecOps, מחזקים פיתוח מאובטח, משפרים הגנה על
                            מידע והצפנה, מזהים חולשות ונקודות תורפה ומקשיחים תהליכים בתשתיות,
                            בפריסה ובענן.
                        </p>
                        <p>
                            העבודה שלנו מחברת בין פיתוח, תשתיות ואבטחה כדי להפוך את ההגנה לחלק
                            מובנה מהתהליך, לא תוספת שמגיעה מאוחר מדי.
                        </p>
                        <div className="signal-list">
                            <div className="signal-item">שילוב פרקטיקות DevSecOps</div>
                            <div className="signal-item">פיתוח מאובטח יותר והקשחת תהליכים</div>
                            <div className="signal-item">הגנה על מידע, הצפנה ובקרות גישה</div>
                            <div className="signal-item">זיהוי חולשות וסקרי סיכונים</div>
                            <div className="signal-item">שיפור אבטחת תשתיות, ענן ותהליכי פריסה</div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">מה יוצא לכם מזה</h3>
                            <div className="trust-grid">
                                <div className="trust-item">רמת הגנה גבוהה יותר ופחות חשיפה לחולשות נפוצות.</div>
                                <div className="trust-item">תהליכי פיתוח ותפעול בטוחים יותר.</div>
                                <div className="trust-item">שמירה טובה יותר על מידע רגיש.</div>
                                <div className="trust-item">יותר שליטה ובהירות לגבי סיכונים.</div>
                                <div className="trust-item">פחות טעויות אנוש בתהליכים קריטיים.</div>
                                <div className="trust-item">בסיס חזק יותר לצמיחה מאובטחת.</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">איך זה עובד</h3>
                            <div className="process-grid">
                                {processSteps.map((step) => (
                                    <div key={step.number} className="process-card">
                                        <span className="process-number">{step.number}</span>
                                        <h4>{step.title}</h4>
                                        <p>{step.text}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">למה לעבוד איתנו</h3>
                            <div className="trust-grid">
                                {trustPoints.map((item) => (
                                    <div key={item} className="trust-item">{item}</div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-8 text-center">
                        <div className="final-cta-card">
                            <h3>אם אתם לא רוצים לגלות את החולשות מאוחר מדי, זה הזמן לעשות סדר</h3>
                            <p className="lead">
                                בואו נבין מה צריך להגן, לייצב ולשפר כדי לבנות סביבת עבודה בטוחה יותר.
                            </p>
                            <div className="security-cta-row">
                                <button
                                    type="button"
                                    className="btn btn-light btn-lg cta-btn"
                                    onClick={scrollToForm}
                                >
                                    השאירו פרטים
                                </button>
                                <a
                                    href={bookingUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="btn btn-outline-light btn-lg cta-btn"
                                >
                                    קבעו שיחת ייעוץ
                                </a>
                            </div>
                            <p className="cta-note">שיחה ראשונית ללא התחייבות. חזרה תוך 24 שעות.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SecuritySolutionsOffer;
